import {
	deepClone,
	timestampFormat,
	getVariableType,
	reservedDecimal,
	debounce,
	unitConvert,
	diffByObj,
	sessionCatch,
	localCatch
} from '@/utils'
import {
	requestBefore
} from '@/api'
import store from '@/store'
import {
	BASE_URL,
	PROXY_NAME
} from '@/config'
import {
	getLoginInfo
} from '@/api/config.js'
import Vue from 'vue'
import Router from '@/router'
import http from '@/api/fetch.js'
export default {
	$jump: (name, params) => {
		Router.push({
			name: name,
			params: params
		})
	},
	$local: localCatch,
	$session: sessionCatch,
	$debounce: debounce,
	$searchJump: async (id, that_) => {
		that_ = that_ || Vue.prototype
		let jumpDetailName = {
			zx: {
				name: '/cultureAround/info/',
				title: '资讯详情'
			},
			hd: {
				name: '/cultureAround/activity/',
				title: '活动详情'
			},
			jcyc: {
				name: '/brilliantEHome/show/',
				title: '精彩演出详情'
			},
			jcpx: {
				name: '/brilliantEHome/train/',
				title: '精彩培训详情'
			},
			whdt: {
				name: '/culturalMap/detail/',
				title: '场馆详情'
			}
		}
		let res = await that_.$http('contentType', {
			contentId: id
		});
		if (res.code === 1) {
			let jumpObj = jumpDetailName[res.data];
			if (!jumpObj.name) return that_.$toast('文章类型有误');
			that_.$router.push({
				path: jumpObj.name + id
			})
		} else {
			return that_.$toast('文章类型有误');
		}
	},
	$diffByObj: diffByObj,
	$backRef: (that_) => {
		that_ = that_ || Vue.prototype
		that_.$router.replace({
			path: that_.$route.query.lastName || '/',
			query: JSON.parse(that_.$route.query.lastParams || '{}')
		})
	},
	$store: store,
	$http: requestBefore,
	$upload: async (file, callback, msg = '图片上传中') => {
		msg && Vue.prototype.$loading(msg);
		let url = '/member/upload/o_upload';
		if (process.env.NODE_ENV === 'development') {
			url = PROXY_NAME + url;
		} else {
			url = url;
			// url = BASE_URL + url;
		}
		let param = new FormData() // 创建form对象
		param.append('uploadFile', file)
		param.append('addToRes', false)
		param.append('JEECMS-Auth-Token', getLoginInfo()['JEECMS-Auth-Token'] || '')
		param.append('Redirect-Header', false)
		param.append('Content-Type', 'application/json')
		param.append('typeStr', 'Image')
		console.log("图片上传中",param)
		// 添加请求头
		let res = await http(url, param, 'post');
		msg && Vue.prototype.$hideLoading();
		callback(res);
},
$deepClone: deepClone,
	$typeof: getVariableType,
}
